import { Style } from '@react-pdf/types/style'

import { SUBJEKT } from './cuzkLvTypes'

export const pdfStyles: { [key: string]: Style } = {
  page: {
    paddingTop: 25,
    paddingBottom: 65,
    fontFamily: 'OpenSans',
    fontSize: 12,
    paddingHorizontal: 35,
  },
  priceEstimatePage: {
    paddingTop: 25,
    paddingBottom: 25,
    fontFamily: 'OpenSans',
    fontSize: 11,
    paddingHorizontal: 35,
  },
  postServiceFrontPage: {
    paddingTop: '2cm',
    paddingBottom: 25,
    fontFamily: 'OpenSans',
    fontSize: 12,
    lineHeight: '1.5em',
    paddingHorizontal: '2cm',
  },
}
export const LvPdfStyle = `.ql-font-emitha-script {font-family: "emitha-script"; font-size: 40px;}.staticHeader{border-bottom:1px solid #dddddd}.mt-0,h2{margin-top:0}.bold,h1{font-weight:700}*{box-sizing:border-box}html{font-size:13px;line-height:1.5em;font-family:courier,courier new,serif}h1{font-size:1.4em;margin:0;text-transform:uppercase;text-align:center}h2{font-size:1em}.noBreakAfter{page-break-after:avoid}.inlineBlock{display:inline-block}.noListStyle{list-style: none}.verticalBottom{display:flex;align-items:flex-end}.breakAll{word-break:break-all}.noShrink{flex-shrink:0}.circleList{list-style-type:circle}.mb-0{margin-bottom:0}.mb-10{margin-bottom:.1cm}.mb-20{margin-bottom:.2cm}.mb-30{margin-bottom:.3cm}.mb-40{margin-bottom:.4cm}.mb-50{margin-bottom:.5cm}.mb-60{margin-bottom:.6cm}.mb-70{margin-bottom:.7cm}.mb-80{margin-bottom:.8cm}.mb-90{margin-bottom:.9cm}.mb-100{margin-bottom:1cm}.mb-150{margin-bottom:1.5cm}.mt-10{margin-top:.1cm}.mt-20{margin-top:.2cm}.mt-30{margin-top:.3cm}.mt-40{margin-top:.4cm}.mt-50{margin-top:.5cm}.mt-60{margin-top:.6cm}.mt-70{margin-top:.7cm}.mt-80{margin-top:.8cm}.mt-90{margin-top:.9cm}.mt-100{margin-top:1cm}.mt-150{margin-top:1.5cm}.ml-0{margin-left:0}.ml-10{margin-left:.1cm}.ml-20{margin-left:.2cm}.ml-30{margin-left:.3cm}.ml-40{margin-left:.4cm}.ml-50{margin-left:.5cm}.ml-60{margin-left:.6cm}.ml-70{margin-left:.7cm}.ml-80{margin-left:.8cm}.ml-90{margin-left:.9cm}.ml-100{margin-left:1cm}.ml-150{margin-left:1.5cm}.mr-0{margin-right:0}.mr-10{margin-right:.1cm}.mr-20{margin-right:.2cm}.mr-30{margin-right:.3cm}.mr-40{margin-right:.4cm}.mr-50{margin-right:.5cm}.mr-60{margin-right:.6cm}.mr-70{margin-right:.7cm}.mr-80{margin-right:.8cm}.mr-90{margin-right:.9cm}.mr-100{margin-right:1cm}.mr-150{margin-right:1.5cm}.pl-0{padding-left:0}.pl-10{padding-left:.1cm}.pl-20{padding-left:.2cm}.pl-30{padding-left:.3cm}.pl-40{padding-left:.4cm}.pl-50{padding-left:.5cm}.pl-60{padding-left:.6cm}.pl-70{padding-left:.7cm}.pl-80{padding-left:.8cm}.pl-90{padding-left:.9cm}.pl-100{padding-left:1cm}.pl-150{padding-left:1.5cm}.pr-0{padding-right:0}.pr-10{padding-right:.1cm}.pr-20{padding-right:.2cm}.pr-30{padding-right:.3cm}.pr-40{padding-right:.4cm}.pr-50{padding-right:.5cm}.pr-60{padding-right:.6cm}.pr-70{padding-right:.7cm}.pr-80{padding-right:.8cm}.pr-90{padding-right:.9cm}.pr-100{padding-right:1cm}.pr-150{padding-right:1.5cm}.-mt-50{margin-top:-.5cm}.text-right{text-align:right}.text-center{text-align:center}.flex-right{justify-content:flex-end}.flexWrap{flex-wrap:wrap}.breakLine{line-break:anywhere}.row{margin-left:0;margin-right:0;display:flex;width:100%;flex-wrap:wrap;page-break-inside:auto}.col-xs-1{width:8.33333333%}.col-xs-2{width:16.66666667%}.col-xs-3{width:25%}.col-xs-4{width:33.33333333%}.col-xs-5{width:41.66666667%}.col-xs-6{width:50%}.col-xs-7{width:58.33333333%}.col-xs-8{width:66.66666667%}.col-xs-9{width:75%}.col-xs-10{width:83.33333333%}.col-xs-11{width:91.66666667%}.col-xs-12{width:100%}`

export const getOpsubShortName = (subj?: SUBJEKT) => {
  const opsub = subj?.OPSUB_NAZEV
  const nameParts = subj?.OPSUB_NAZEV?.bsm1_id
    ? [
        appendSpace(opsub?.bsm1_pred),
        appendSpace(opsub?.bsm1_prijmeni),
        opsub?.bsm1_za
          ? appendComa(opsub?.bsm1_jmeno?.slice(0, 1) + '.')
          : appendSpace(opsub?.bsm1_jmeno?.slice(0, 1) + '.'),
        appendSpace(opsub?.bsm1_za),
        'a ',
        appendSpace(opsub?.bsm2_pred),
        appendSpace(opsub?.bsm2_prijmeni),
        opsub?.bsm2_za
          ? appendComa(opsub?.bsm2_jmeno?.slice(0, 1) + '.')
          : appendSpace(opsub?.bsm2_jmeno?.slice(0, 1) + '.'),
        appendComa(opsub?.bsm2_za),
      ]
    : [
        appendSpace(opsub?.nazev),
        appendSpace(opsub?.titul_pred),
        appendSpace(opsub?.prijmeni),
        opsub?.titul_za ? appendComa(opsub?.jmeno) : appendSpace(opsub?.jmeno),
        appendSpace(opsub?.titul_za),
      ]

  const nameTitle = nameParts.join('').trim()
  return nameTitle.length > 25 ? nameTitle.slice(0, 25) + '...' : nameTitle
}

export const appendSpace = (value?: string | (string | undefined)[]) =>
  value ? `${value} ` : ''

export const appendComa = (value?: string | (string | undefined)[]) =>
  value ? `${value}, ` : ''

export const safeMap = <T, U>(
  arr: T[] | T | undefined,
  callback: (value: T, index: number, array: T[]) => U
): U[] => {
  const normalizedArray = Array.isArray(arr) ? arr : arr ? [arr] : []
  return normalizedArray.map(callback)
}

export function safeFind<T>(
  arr: T[] | T | undefined,
  callback: (
    value: T | undefined,
    index: number,
    array: (T | undefined)[]
  ) => boolean
): T | undefined {
  const normalizedArray = Array.isArray(arr) ? arr : [arr]
  return normalizedArray.find(callback)
}

export function safeFilter<T>(
  arr: T[] | T | undefined,
  callback: (value: T, index: number, array: T[]) => boolean
): T[] {
  const normalizedArray = Array.isArray(arr) ? arr : arr ? [arr] : []
  return normalizedArray.filter(callback)
}

export function safeJoin(
  arr: unknown[] | string | undefined,
  separator: string
): string {
  if (Array.isArray(arr)) {
    return arr.join(separator)
  }
  if (typeof arr === 'string') {
    return arr
  }
  return ''
}

export function safeLength<T>(arr: T[] | T | undefined): number {
  const normalizedArray = Array.isArray(arr) ? arr : arr ? [arr] : []
  return normalizedArray.length
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function notEmpty(value: any): boolean {
  if (Array.isArray(value)) {
    return value.some(item => item !== undefined)
  }

  if (typeof value === 'string') {
    return true
  }

  if (typeof value === 'object' && value !== null) {
    const keys = Object.keys(value)
    return keys.some(key => value[key] !== undefined)
  }

  return false
}

export function removeDiacritics(
  text?: string,
  lowcase?: boolean,
  replaceSpace?: boolean
) {
  if (!text) return ''
  let normalize = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  if (lowcase) normalize = normalize.toLowerCase()
  if (replaceSpace) normalize = normalize.replace(/\s/g, '-')
  return normalize
}

export function normalizeMaybeArray<T>(value: T | T[] | null | undefined): T[] {
  if (value === null || value === undefined) return []
  if (Array.isArray(value)) return value
  return [value]
}

export const sanitizeFileName = (
  title?: string | null | number,
  prefix?: string,
  suffix?: string
): string => {
  const MAX_LENGTH = 45
  const defaultName = 'REGESTA-PDF'

  if (!title) {
    return prefix || suffix
      ? `${prefix || ''}${defaultName}${suffix || ''}`
      : defaultName
  }

  const titleStr = String(title)

  const withoutDiacritics = titleStr
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')

  const sanitized = withoutDiacritics
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')

  const prefixLength = prefix ? prefix.length : 0
  const suffixLength = suffix ? suffix.length : 0
  const availableLength = MAX_LENGTH - prefixLength - suffixLength

  const truncated = sanitized.substring(0, Math.max(1, availableLength))

  return `${prefix || ''}${truncated}${suffix || ''}`
}
